import {Inject, Injectable} from '@angular/core';
import {FILE_CONFIG, FileConfig} from '@docma-mm-core/config/file-config';
import {BasedataService} from '@docma-mm-core/shared/basedata.service';
import {HttpClient} from '@angular/common/http';
import {ConfigService} from '@docma-mm-core/config/config.service';
import {firstValueFrom, Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {File} from './models/file';
import { Logger } from '@mydocma/common/src/lib/logger';

@Injectable()
export class FileApiService extends BasedataService {

  constructor(private http: HttpClient, configService: ConfigService,
              @Inject(FILE_CONFIG) private fileConfig: FileConfig,
              private readonly logger: Logger) {
    super(configService);
  }

  search(subId: string): Promise<File[]> {
    const endpoint = `${this.fileConfig.apiUrl.replace(/\/+$/, '')}/metadata/search`;

    const body = {
      userId: subId,
      contentType: 'mm.DefectsExport',
      downloaded: false
    };
    return firstValueFrom(this.http.post<File[]>(endpoint, JSON.stringify(body), { headers: this.getHeaders() })
      .pipe(
        map(x => {
          return x;
        }),
        catchError((e) => {
          this.logger.error(e, '', 'FileApiService');
          return of(null);
        })
      ));
  }

  delete(id: string) {
    const endpoint = `${this.fileConfig.apiUrl.replace(/\/+$/, '')}/file/${id}`;

    return firstValueFrom(this.http.delete(endpoint, { headers: this.getHeaders() })
      .pipe(catchError(e  => {
        this.logger.error(e, '', 'FileApiService');
        return of(null);
      })));
  }

}
